import { render } from "./SettingSvgIcon.vue?vue&type=template&id=336e982c"
import script from "./SettingSvgIcon.vue?vue&type=script&lang=js"
export * from "./SettingSvgIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__